import type {HubConnection} from '@microsoft/signalr'

let current: HubConnection | null = null

/** The interpreter tab's live /interpreterHub connection, if one is open. */
export function getInterpreterHubConnection(): HubConnection | null {
  return current
}

export function setInterpreterHubConnection(connection: HubConnection): void {
  current = connection
}

/** Clear only if this connection is still the registered one (strict-mode remounts). */
export function clearInterpreterHubConnection(connection: HubConnection): void {
  if (current === connection) current = null
}
